import React from "react";
import star_solid from "./images/star_solid.png";
import star_empty from "./images/star_empty.png";
import star_half from "./images/star_half.png";
import "./css/ActivityCard.css";

function ActivityCard(props) {
  console.log(props.priceFor);
  let priceFor = "";
  if (props.priceFor === "Per Person") {
    priceFor = "/Person";
  } else if (props.priceFor === "Per Vehicle") {
    priceFor = "/Vehicle";
  } else if (props.priceFor === "Flat Rate") {
    priceFor = "Flat";
  } else if (props.priceFor === "Per Couple") {
    priceFor = "/Couple";
  } else if (props.priceFor === "Per Boat") {
    priceFor = "/Boat";
  } else {
    priceFor = "";
  }
  return (
    <div className="offset-sm-1 col-sm-10 col-md-4 col-lg-3 col-xl-3 activity-card-container">
      <div className={`activityCard ${props.className}`}>
        <a href={props.activityUrl + "?af=" + props.affiliateName} target="_blank">
          <div
            className="activityImage"
            style={{
              backgroundImage: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
              width: "100%",
              height: "12rem",
              position: "relative"
            }}
          >
            <ActivityImage src={props.activityImage} />
            {/*<DiscountPercent discount={props.discount}/>*/}
          </div>
          <div className="activityInfo">
            <ActivityName name={props.activityName} />
            <ActivityLocationNStar reviewCount={props.reviewCount} rating={props.rating} location={props.location} />
            <div
              className="divider"
              style={{
                height: 1,
                width: "100%",
                backgroundColor: "#dfdfdf",
                margin: "0.5rem 0"
              }}
            />
            <div className="activityDetails">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <StartingPoint startPoint={props.startPoint} />
                <MinBooking minBooking={props.minBooking} />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "0.2rem"
                }}
              >
                <Duration duration={props.duration} />
                <NextAvailable nextAvailable={props.nextAvailable} />
              </div>
            </div>
            <div
              className="divider"
              style={{
                height: 1,
                width: "100%",
                backgroundColor: "#dfdfdf",
                margin: "0.5rem 0"
              }}
            />
            <div className="pricing">
              {props.discount === 0 && <h5>Starting</h5>}
              {props.discount !== 0 && (
                <h5 style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <span
                    style={{ textDecoration: "line-through", color: "#afafaf" }}
                    dangerouslySetInnerHTML={showPrice(props.oldPrice)}
                  />
                  <span
                    style={{
                      backgroundColor: "#fdcd26",
                      marginLeft: "0.5rem",
                      padding: "0.2rem",
                      fontSize: "0.6rem",
                      borderRadius: 5
                    }}
                  >
                    {props.discount}% Off
                  </span>
                </h5>
              )}
              <div
                className="price"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "baseline"
                }}
              >
                <div className="amount">
                  <p dangerouslySetInnerHTML={showPrice(props.price)} />
                </div>
                <div className="price-type">
                  <p>{priceFor}</p>
                </div>
                <div className="labels" style={{ display: "flex" }}>
                  {props.instantBooking && (
                    <span>
                      <img src="https://images.trodly.com/homepagev2/instant_booking.svg" alt="" />
                    </span>
                  )}
                  {props.guaranteedDeparture && (
                    <span>
                      <img src="https://images.trodly.com/homepagev2/guaranteed_departure.svg" alt="" />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}
function showPrice(price) {
  return { __html: price };
}
function ActivityImage(props) {
  const style = {
    backgroundImage: `url(${props.src})`,
    width: "100%",
    height: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundOrigin: "center",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5
  };
  return <div style={style} />;
}
function DiscountPercent(props) {
  const style = {
    backgroundColor: "#fdcd26",
    color: "#484848",
    position: "absolute",
    top: "5%",
    right: "5%",
    padding: "0.5rem",
    fontSize: "0.8rem",
    borderRadius: 10
  };

  return (
    <div>
      {props.discount !== 0 && (
        <div style={style}>
          <span>{props.discount}% Off</span>
        </div>
      )}
    </div>
  );
}
function ActivityName(props) {
  return (
    <div>
      <h2 title={props.name}>{props.name}</h2>
    </div>
  );
}
function ActivityLocationNStar(props) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <div style={{ overflow: "hidden" }}>
        <h3 title={props.location}>{props.location}</h3>
      </div>
      <div>
        <Rating rating={props.rating} reviewCount={props.reviewCount} />
      </div>
    </div>
  );
}
function Rating(props) {
  let element = [];
  for (let i = 0; i < parseInt(props.rating, 10); i++) {
    element.push(
      <img src={star_solid} key={i} alt="" style={{ display: "block", width: "0.6rem", marginRight: "0.2rem" }} />
    );
  }
  let afterDot = props.rating.substring(props.rating.indexOf(".") + 1);
  if (afterDot !== "0") {
    element.push(
      <img
        src={star_half}
        key="half-star"
        alt=""
        style={{ display: "block", width: "0.6rem", marginRight: "0.2rem" }}
      />
    );

    for (let index = parseInt(props.rating, 10) + 1; index < 5; index++) {
      element.push(
        <img src={star_empty} key={index} alt="" style={{ display: "block", width: "0.6rem", marginRight: "0.2rem" }} />
      );
    }
  } else {
    for (let index = parseInt(props.rating, 10); index < 5; index++) {
      element.push(
        <img src={star_empty} key={index} alt="" style={{ display: "block", width: "0.6rem", marginRight: "0.2rem" }} />
      );
    }
  }
  return (
    <div>
      {parseInt(props.rating, 10) !== 0 && (
        <div style={{ display: "flex", alignItems: "center" }}>
          {element}
          <span style={{ fontSize: "0.75rem" }}>{parseInt(props.rating, 10) !== 0 ? props.reviewCount : ""}</span>
        </div>
      )}
    </div>
  );
}
function StartingPoint(props) {
  return (
    <div
      style={{
        flexGrow: 1,
        flexBasis: "50%",
        overflow: "hidden",
        marginRight: "0.5rem"
      }}
    >
      <h4>
        <span>Start point: </span>
        <span title={props.startPoint}>{props.startPoint}</span>
      </h4>
    </div>
  );
}
function MinBooking(props) {
  return (
    <div style={{ flexGrow: 1, flexBasis: "50%" }}>
      <h4>
        <span>Min. members: </span>
        <span title={props.minBooking}>{props.minBooking}</span>
      </h4>
    </div>
  );
}
function Duration(props) {
  return (
    <div style={{ flexGrow: 1, flexBasis: "50%", marginRight: "0.5rem" }}>
      <h4>
        <span>Duration: </span>
        <span title={props.duration}>{props.duration}</span>
      </h4>
    </div>
  );
}
function NextAvailable(props) {
  return (
    <div style={{ flexGrow: 1, flexBasis: "50%" }}>
      <h4>
        <span>Next: </span>
        <span title={props.nextAvailable}>{props.nextAvailable}</span>
      </h4>
    </div>
  );
}
export default ActivityCard;



// WEBPACK FOOTER //
// ./src/ActivityCard.jsx